import { useField } from '../api/useField';
import { Choice } from './choiceUtils';

export function useFieldSelectOptions(entity: string, field: string): Array<Choice>{
  const { formatedField } = useField(entity, field);

  const choices = formatedField?.settings?.options?.choices || [];
  return choices.filter((choice): choice is Choice =>
    typeof choice.text === 'string' && typeof choice.value === 'string'
  );
}
